import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../../util';
import {API, BROKERID, TICKER_API} from "../../../../config";
import axios from "axios";

const moment = require('moment');

const holdings = API.service('holdings');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InvestorWithdrawals extends Component {
    state={
        holdings:[],
        companies:{},
    };

    getHoldings = () => {
        const app = this;
        axios.get(TICKER_API + '/companies?$sort[name]=1&broker_exclusive[$in]=0&broker_exclusive[$in]='+BROKERID).then(x=> {
            let companies = {}
            x.data.forEach(c=>{
                companies[c.symbol] = c
            });
            app.setState({
                companies: companies
            });

            holdings.find({
                query: {
                    _investor_account: this.props.investor._account,
                    _type: {$ne: 'DEAD'},
                    incl: ['company']
                }
            }).then(s => {
                console.log('holdings:', s);
                app.setState({
                    holdings: s.data
                })
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.investor._id !== this.props.investor._id)) {
            this.getHoldings()
            this.props.context.update({
                holdingsUpdates:false
            })
        }
    }

    timer = null;

    componentDidMount() {
        const app = this;
        this.getHoldings()

        this.timer = setInterval(function(){
            app.getHoldings();
        },3000)
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <table className={'w-full'}>
                    <tr className={classes.tableHead}>
                        <td>Symbol</td>
                        <td className={'text-center pl-2'}>Type</td>
                        <td className={'text-center pl-2'}>Restricted Until</td>
                        <td className={'text-center pl-2'}>Quantity</td>
                        <td className={'text-center pl-2'}>Value</td>
                    </tr>
                    {this.state.holdings.map((v,i)=>{
                            return (
                                <tr>
                                    <td>{(v.company !== null) ? v.company._trading_symbol : 'ERR '+ v._company_account}</td>
                                    <td className={'text-center pl-2'}>{v._type}</td>
                                    <td className={'text-center pl-2'}>{(v._restricted_until_date) ? moment(v._restricted_until_date).format('L') : ''}</td>
                                    <td className={'text-center pl-2'}>{Utils.addThousandCommas(v._quantity, '0,0')}</td>
                                    {(v.company !== null) &&
                                    <td className={'text-center pl-2'}>
                                        {(typeof this.state.companies[v.company._trading_symbol] !== 'undefined' && this.state.companies[v.company._trading_symbol].share_type !== 'D') &&
                                        <React.Fragment>
                                            {Utils.getCurrency(this.state.companies[v.company._trading_symbol].currency).currency_symbol}
                                            {Utils.addThousandCommas(this.state.companies[v.company._trading_symbol].share_price * v._quantity, '0,00')}
                                        </React.Fragment>
                                        }
                                        {(typeof this.state.companies[v.company._trading_symbol] !== 'undefined'&& this.state.companies[v.company._trading_symbol].share_type === 'D') &&
                                        <React.Fragment>
                                            {Utils.addThousandCommas((this.state.companies[v.company._trading_symbol].share_price / 100) * v._quantity, '0,00')}
                                        </React.Fragment>
                                        }
                                    </td>
                                    }
                                </tr>
                            )
                    })}
                </table>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorWithdrawals)));
